
import { Component } from 'vue-property-decorator';
import { SettingsApiUiClient, SettingItemUser } from '../../backend/backendapi';
import { initClient } from '../../../api';
import Vue from 'vue';
import {filterSettingsByPrefix} from "../setting_utils";

@Component
export default class Tab1 extends Vue {
  private readonly settings: SettingItemUser[] = [];
  private readonly service = initClient(SettingsApiUiClient);

  mounted() {
    this.fetchSettings();
  }

  // Computed property to group items by category automatically
  get sortedSettings(): SettingItemUser[] {
    return [...this.settings].sort((a, b) => a.category.localeCompare(b.category));
  }

  fetchSettings(): void {
    this.service.listListSettingUser()
      .then(data => {
        let filteredData = filterSettingsByPrefix(data, "Reporting");
        this.settings.splice(0);
        this.settings.push(...filteredData);
      });
  }

  postSettings(): void {
    this.service.updateUserSetting(this.settings)
      .then(_ => this.$toasted.info(this.$t('txtDone').toString()))
      .catch(e => this.$toasted.error(this.$t('txtError').toString()));
  }

  get checkedNames() {
    return this.settings.filter(item => item.isChecked).map(name => name.name)
  }
}
